export const LOG_NAMES = [
    'VETTING',
    'VETTING-ENGINE',
    'VETTING-ENGINE-ADMIN',
    'MATCHING',
    'SELF-SERVE',
    'CUSTOMER-FLOW',
    'DEVELOPER-COMMUNICATIONS-PLATFORM',
    'VETTING_DATABASE_CHANGE',
    'MATCHING_DATABASE_CHANGE',
    'LOGGING-SERVER',
    'PAGEVIEWS',
    'TURING.COM',
    'CALENDAR',
    'EXPERIMENTS',
    'SELF-SERVE-LIGHT',
    'CHAT',
];
export const HALF_HOUR = 1800000;
export const SESSION_TOKEN_REVALIDATION_TIMEOUT = HALF_HOUR;
export const COMMON_PROPS_REFETCH_TIMEOUT = 300000;
export const PACKAGE_VERSION = '6.12.1';
export const EVENT_THROTTLE_LIMIT = 500;
//# sourceMappingURL=constants.js.map